import {observer} from 'mobx-react';
import {BrowserRouter as Router, Switch} from 'react-router-dom';
import {withState} from 'shared/core';
import {auth} from 'main/tools';
import PayrollNotEnabledSwitch from './PayrollNotEnabledSwitch';
import PayrollEnabledSwitch from './PayrollEnabledSwitch';
import {PayrollPageState} from './state';
import {NmbrPage} from 'main/containers/nmbr';

const PayrollPage = observer(({uiState}) => {
  const {scope} = uiState;

  if (auth.company.showNmbrPayroll) {
    return (
      <Router basename='/payroll'>
        <NmbrPage/>
      </Router>
    );
  }

  return (
    <Router basename='/payroll'>
      <Switch>
        {auth.company.payrollEnabled
          ? <PayrollEnabledSwitch scope={scope}/>
          : <PayrollNotEnabledSwitch/>
        }
      </Switch>
    </Router>
  );
});

export default withState(PayrollPage, PayrollPageState);
